export const GET_ALL_VEHICULE_REQUEST = "GET_ALL_VEHICULE_REQUEST";
export const GET_ALL_VEHICULE_SUCCESS = "GET_ALL_VEHICULE_SUCCESS";
export const GET_ALL_VEHICULE_FAIL = "GET_ALL_VEHICULE_FAIL";

export const ADD_VEHICULE_REQUEST = "ADD_VEHICULE_REQUEST";
export const ADD_VEHICULE_SUCCESS = "ADD_VEHICULE_SUCCESS";
export const ADD_VEHICULE_FAIL = "ADD_VEHICULE_FAIL";

export const UPDATE_VEHICULE_REQUEST = "UPDATE_VEHICULE_REQUEST";
export const UPDATE_VEHICULE_SUCCESS = "UPDATE_VEHICULE_SUCCESS";
export const UPDATE_VEHICULE_FAIL = "UPDATE_VEHICULE_FAIL";

export const DELETE_VEHICULE_REQUEST = "DELETE_VEHICULE_REQUEST";
export const DELETE_VEHICULE_SUCCESS = "DELETE_VEHICULE_SUCCESS";
export const DELETE_VEHICULE_FAIL = "DELETE_VEHICULE_FAIL";